import "./App.css";
import { BrowserRouter } from "react-router-dom";
import "./style/style.css";
import Router from "./routes/root";

function App() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}

export default App;
